// services/api-keys.service.ts

import { AxiosRequestConfig } from "axios";
import { callExternalApi } from "./external-api.service";
import {
  ApiKey,
  CreateApiKeyResponse,
  ListApiKeysResponse,
} from "../models/api-key";
import { AppError } from "../models/app-error";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const getApiKeys = async (
  accessToken: string
): Promise<ListApiKeysResponse> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/api-keys`,
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const { data, error } = await callExternalApi({ config });

  if (error) {
    return { apiKeys: null, error };
  }

  const apiKeys = (data as unknown as { api_keys: ApiKey[] }).api_keys;
  return { apiKeys, error: null };
};

export const createApiKey = async (
  accessToken: string,
  name: string
): Promise<CreateApiKeyResponse> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/api-keys`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: { name },
  };

  const { data, error } = await callExternalApi({ config });

  if (error) {
    return { key: null, apiKey: null, error };
  }

  const body = data as unknown as { key: string; api_key: ApiKey };
  return { key: body.key, apiKey: body.api_key, error: null };
};

export const deleteApiKey = async (
  accessToken: string,
  id: string
): Promise<{ error: AppError | null }> => {
  const config: AxiosRequestConfig = {
    url: `${apiServerUrl}/api/api-keys/delete`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: { id },
  };

  const { error } = await callExternalApi({ config });
  return { error };
};
